export enum ProductType {
    SimpleProduct = 0,
    GroupedProduct = 10,
    Reservation = 20,
    BundledProduct = 30,
    Auction = 40
}